const inputErrors = (values, fields = []) => {
    let errors = {};

    fields.forEach((name) => {

        switch (name) {

            case "eventDate":
                if (values.eventDate) {
                    const today = new Date();

                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, "0");
                    const day = String(today.getDate()).padStart(2, "0");

                    const currentDate = `${year}-${month}-${day}`;

                    if (values.eventDate < currentDate) {
                        errors.eventDate =
                            `Invalid date Value must be ${currentDate} or above`;
                    }
                }
                break;


            case "email":
                if (!values.email) {
                    errors.email = "Please enter email";
                } else if (
                    !/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/i.test(
                        values.email
                    )
                ) {
                    errors.email = "Please enter valid email";
                }
                break;

            case "eventName":
                if (!values.eventName) {
                    errors.eventName = "Event name is required";
                } else if (values.eventName.length > 30) {
                    errors.eventName =
                        "Max length reached [Allowed Characters 30]";
                }
                break;


            case "eventTime":
                if (!values.eventTime) {
                    errors.eventTime = "Event Time is required";
                } else if (values.eventTime === "Invalid Date") {
                    errors.eventTime = "Enter valid time";
                }
                break;


            case "eventTheme":
                if (values.eventTheme && values.eventTheme.length > 150) {
                    errors.eventTheme =
                        "Max length reached [Allowed Characters 80]";
                }
                break;


            case "eventAddress":
                if (values.eventAddress && values.eventAddress.length > 100) {
                    errors.eventAddress =
                        "Max length reached [Allowed Characters 100]";
                }
                break;


            case "eventInfo":
                if (values.eventInfo && values.eventInfo.length > 200) {
                    errors.eventInfo =
                        "Max length reached [Allowed Characters 200]";
                }
                break;


            case "groomName":
                if (!values.groomName) {
                    errors.groomName = "Groom First Name is required";
                } else if (values.groomName.length > 15) {
                    errors.groomName =
                        "Max length reached [Allowed Characters 15]";
                }
                break;


            case "brideName":
                if (!values.brideName) {
                    errors.brideName = "Bride First Name is required";
                } else if (values.brideName.length > 15) {
                    errors.brideName =
                        "Max length reached [Allowed Characters 15]";
                }
                break;


            case "groomFullName":
                if (!values.groomFullName) {
                    errors.groomFullName =
                        "Groom Full Name is Required";
                } else if (values.groomFullName.length > 35) {
                    errors.groomFullName =
                        "Max length reached [Allowed Characters 35]";
                }
                break;


            case "brideFullName":
                if (!values.brideFullName) {
                    errors.brideFullName =
                        "Bride Full Name is Required";
                } else if (values.brideFullName.length > 35) {
                    errors.brideFullName =
                        "Max length reached [Allowed Characters 35]";
                }
                break;


            case "hashtag":
                // Hashtag is optional
                if (values.hashtag && values.hashtag.length > 20) {
                    errors.hashtag =
                        "Max length reached [Allowed Characters 20]";
                }
                break;


            case "groomParents":
                if (
                    values.groomParents &&
                    values.groomParents.length > 70
                ) {
                    errors.groomParents =
                        "Max length reached [Allowed Characters 70]";
                }
                break;

                 case "groomGrandParents":
                if (
                    values.groomGrandParents &&
                    values.groomGrandParents.length > 70
                ) {
                    errors.groomGrandParents =
                        "Max length reached [Allowed Characters 70]";
                }
                break;

                case "groomParentsPrefix":
    if (
        values.groomParentsPrefix &&
        values.groomParentsPrefix.length > 25
    ) {
        errors.groomParentsPrefix =
            "Prefix Max length reached [Allowed Characters 25]";
    }
    break;

case "groomGrandParentsPrefix":
    if (
        values.groomGrandParentsPrefix &&
        values.groomGrandParentsPrefix.length > 25
    ) {
        errors.groomGrandParentsPrefix =
            "Prefix Max length reached [Allowed Characters 25]";
    }
    break;


       case "brideParentsPrefix":
    if (
        values.brideParentsPrefix &&
        values.brideParentsPrefix.length > 25
    ) {
        errors.brideParentsPrefix =
            "Prefix Max length reached [Allowed Characters 25]";
    }
    break;

case "brideGrandParentsPrefix":
    if (
        values.brideGrandParentsPrefix &&
        values.brideGrandParentsPrefix.length > 25
    ) {
        errors.brideGrandParentsPrefix =
            "Prefix Max length reached [Allowed Characters 25]";
    }
    break;

    case "withRegardsTitle":
    if (
        values.withRegardsTitle &&
        values.withRegardsTitle.length > 30
    ) {
        errors.withRegardsTitle =
            "Max length reached [Allowed Characters 30]";
    }
    break;

     case "withRegards":
    if (
        values.withRegards &&
        values.withRegards.length > 50
    ) {
        errors.withRegards =
            "Max length reached [Allowed Characters 50]";
    }
    break;
   

            case "sectionHeading":
                if (
                    values.sectionHeading &&
                    values.sectionHeading.length > 25
                ) {
                    errors.sectionHeading =
                        "Max length reached [Allowed Characters 25]";
                }
                break;


            case "brideParents":
                if (
                    values.brideParents &&
                    values.brideParents.length > 70
                ) {
                    errors.brideParents =
                        "Max length reached [Allowed Characters 70]";
                }
                break;

                 case "brideGrandParents":
                if (
                    values.brideGrandParents &&
                    values.brideGrandParents.length > 70
                ) {
                    errors.brideGrandParents =
                        "Max length reached [Allowed Characters 70]";
                }
                break;


            case "preWeddingLink":
                if (
                    values.preWeddingLink &&
                    !/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(
                        values.preWeddingLink
                    )
                ) {
                    errors.preWeddingLink = "Please enter a valid URL";
                }
                break;
            case "coverText":
                if (values.coverText   && values.coverText.length > 64) {
                    errors.coverText   =
                        "Max length reached [Allowed Characters 64 (32 each line)]";
                }
                break;


            case "blessingMessage":
                if (
                    values.blessingMessage &&
                    values.blessingMessage.length > 220
                ) {
                    errors.blessingMessage =
                        "Max length reached [Allowed Characters 220]";
                }
                break;


            default:
                break;
        }
    });

    return errors;
};

export default inputErrors;